<template>
    <div class="content-body" id="tender">
        <div class="row match-height">
            <div class="col-md-12">                        
                <div class="card">
                    <div class="card-header">
                        <h3 class="card-title"><i class="icon-price-tags"></i> {{$t('titles.user_messages')}}</h3>
                        <div class="heading-elements">                           
                           
                        </div>
                    </div>
                    <div class="px-2 py-2" >
                        <form>
                            <div class="form-group">
                                <label for="inputEmail">Email address</label>
                                <input type="email" v-model="form.email" class="form-control" id="inputEmail" aria-describedby="emailHelp" placeholder="Enter email">
                            </div>            
                            <div class="form-group">
                                <label for="title">Titles</label>
                                <input type="text" v-model="form.title" class="form-control" id="title"  placeholder="Title">           
                            </div>        
                            <div class="form-group">
                                <label for="title">Message</label>
                                <wysiwyg v-model="form.message" />        
                            </div>        
                            <button type="submit" @click.prevent="sendMessage" class="btn btn-success btn-lg float-right ">Send</button>
                        </form>
                    </div>
                </div>                        
            </div>
        </div>     
    </div> 
</template>
<script>

  export default {
    name: "contakt_as",
    data(){
      return{
          form:{
              email:"",
              title:"",
              message:""
          },      
             
         }    
    },
    methods: {
         sendMessage(){
             let dataRequest = {
               email: this.form.email,
               title: this.form.title,
               message: this.form.message,
            }; 
            this.makeQuery("/service/addComplaint", { dataRequest: dataRequest, token: this.$store.getters.getUserToken })
                .then(result => {
                    if (result.data.result){
                         this.showNotification('custom-success','Changing','Повідомлення відправлено'); 
                         this.form.title="",                       
                         this.form.message=""                      
                    }
                    else{
                         this.showNotification('custom-error','Помилка','Повідомлення не відправлено');
                    }
                   
                }); 
        },
         
    },
    computed:{     
     
    },
    created() {},
    mounted(){ 
    },
    beforeMount() { 
      this.form.email = this.$store.getters.getUserEmail;
      
    //   this.rowData = this.$props.rowData 
    },
  }
</script>

<style scoped>
#tender fieldset {
  padding: 10px;
}

.ms-data {
    color: rgb(212, 211, 211);
}
.ms-title{}
.ms-body {}
.icon {
    height: 15px;
    width: 15px;
    float: left;   
    margin-top: 5px;
    margin-right: 5px;
    font-size: 11px;
}
.svg {
    overflow: hidden;
    vertical-align: middle;
}
</style> 


// WEBPACK FOOTER //
// src/pages/contakt_as.vue